var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from 'aurelia-templating';
import { autoinject, transient } from 'aurelia-dependency-injection';
import { computedFrom } from "aurelia-binding";
import { Reflection } from '../../../utilities/reflection';
var Collapsable = /** @class */ (function () {
    function Collapsable(element) {
        this.element = element;
        this.isOpen = true;
        this.isTitleHtml = false;
        this.titleReplaceable = false;
    }
    Object.defineProperty(Collapsable.prototype, "titleInternal", {
        get: function () {
            if (typeof (this.label) === "function") {
                return this.isTitleHtml ? { html: this.label(), bindingContext: {} } : this.label();
            }
            else if (typeof this.label == "string") {
                return this.isTitleHtml ? { html: this.label, bindingContext: {} } : this.label;
            }
            return this.label ? this.label : { html: '', bindingContext: {} };
        },
        enumerable: false,
        configurable: true
    });
    Collapsable.prototype.isOpenChanged = function () {
        var box = $(this.element).find(".collapsable-body");
        box.stop();
        if (!this.isOpen) {
            box.slideUp();
        }
        else {
            box.slideDown();
        }
    };
    Collapsable.prototype.toggle = function ($event) {
        this.isOpen = !this.isOpen;
    };
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], Collapsable.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Collapsable.prototype, "isOpen", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.label; })),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Collapsable.prototype, "titleInternal", null);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Collapsable.prototype, "isTitleHtml", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Collapsable.prototype, "titleReplaceable", void 0);
    Collapsable = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element])
    ], Collapsable);
    return Collapsable;
}());
export { Collapsable };
